














import Vue from 'vue'
import { IDevice, IVW } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin, generalDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { OsdConfig, OsdImage } from '@/types/api'

// FIXME: Validator before delete (VideoWall + Matrix + Preset)

export default mixins(generalDialogMixin).extend({
  data (): {
    imgid: number,
  } {
    return {
      imgid: -1
    }
  },
  computed: {
    osdImg (): OsdImage | null {
      return this.$state.device.osd.imgList.find(x => x.id === this.imgid) || null
    }
  },
  methods: {
    async apply () {
      if (!this.osdImg) { console.error('[To Developer] Impossible.'); return }
      const ok = await easyapi.deleteOsdImg(this.osdImg)
      if (ok) {
        this.closeThisDialog()
      }
    }
  },
  mounted () {
    this.imgid = ~~this.$route.params.imgid
  }
})
